export default __webpack_public_path__ + "static/media/collaborate.82a85362.svg";